import React from 'react';

const AddressSuggestionCard = ({ title, children }) => (
  <div
    key="shipping-modal-original-address-card"
    className="flex flex-col border-solid border-[1px] border-gray-dark grow rounded-md"
  >
    <div className="border-b-[1px] border-solid border-gray-dark bg-gray-light8 text-xl p-2 rounded-tl-md rounded-tr-md">
      {title}
    </div>
    <div className="flex flex-col grow justify-between p-6">{children}</div>
  </div>
);

export default AddressSuggestionCard;
